import axios from "axios";

export function fetchTemplateDropdown() {
  return new Promise((resolve, reject) => {
    axios.get("/serialnumber/api/v1/product-ui-template/template-dropdown")
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data))
  })
}
